module.exports = __webpack_public_path__ + "static/media/no-payments.737a46f5.png";